import produce from 'immer';
import { ICheckoutInitialState, types } from './types';
import { types as campaignTypes } from '../contest/types';

export const initialState: ICheckoutInitialState = {
    isOpen: false,
    items: [],
    processing: false,
    currency: 'usd',
    originalCurrency: 'usd',
    refundingTickets: {},
    calculatingFees: false,
};

const reducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {
        case types.OPEN_CHECKOUT:
            return produce(state, draft => {
                draft.isOpen = true;
                draft.items = payload.items;
                if (payload.currency) {
                    draft.currency = payload.currency;
                }
                if (payload.currencyInfo) {
                    draft.currencyInfo = payload.currencyInfo;
                }
                if (payload.saleObject) {
                    draft.saleObject = payload.saleObject;
                }
                draft.error = undefined;
                draft.success = false;
            });
        case types.CLOSE_CHECKOUT:
            return produce(state, draft => {
                draft.isOpen = false;
            });
        case types.SET_CHECKOUT_ITEMS:
            return produce(state, draft => {
                draft.items = payload.items;
            });
        case types.ADD_CHECKOUT_ITEM:
            return produce(state, draft => {
                const existingItemIndex = draft.items.findIndex(item => item.id === payload.item.id);
                if (existingItemIndex >= 0) {
                    draft.items[existingItemIndex].quantity += payload.item.quantity;
                } else {
                    draft.items.push(payload.item);
                }
            });
        case types.REMOVE_CHECKOUT_ITEM:
            return produce(state, draft => {
                draft.items = draft.items.filter(item => item.id !== payload.itemId);
            });
        case types.UPDATE_CHECKOUT_ITEM_QUANTITY:
            return produce(state, draft => {
                const itemIndex = draft.items.findIndex(item => item.id === payload.itemId);
                if (itemIndex >= 0) {
                    draft.items[itemIndex].quantity = payload.quantity;
                }
            });
        case types.APPLY_DISCOUNT:
            return produce(state, draft => {
                draft.discount = payload;
            });
        case types.REMOVE_DISCOUNT:
            return produce(state, draft => {
                draft.discount = undefined;
            });
        case types.SET_PAYMENT_METHOD:
            return produce(state, draft => {
                draft.selectedPaymentMethod = payload.paymentMethod;
            });
        case types.PROCESS_PAYMENT:
            return produce(state, draft => {
                draft.processing = true;
                draft.error = undefined;
                draft.success = false;
            });
        case types.PROCESS_PAYMENT_SUCCESS:
            return produce(state, draft => {
                draft.processing = false;
                draft.success = true;
                draft.isOpen = false;
                draft.saleObject = undefined;
                draft.currencyInfo = undefined;
                draft.currency = '';
            });
        case types.PROCESS_PAYMENT_FAIL:
            return produce(state, draft => {
                draft.processing = false;
                draft.error = payload;
            });
        case types.RESET_CHECKOUT:
            return initialState;
        case types.INITIATE_REFUND:
            return produce(state, draft => {
                draft.refundingTickets[payload.ticketId] = 'refund-in-progress';
            });
        case types.INITIATE_REFUND_SUCCESS:
            return produce(state, draft => {
                draft.refundingTickets[payload.ticketId] = payload.state;
            });
        case types.INITIATE_REFUND_FAIL:
            return produce(state, draft => {
                delete draft.refundingTickets[payload.ticketId];
            });
        case types.CALCULATE_FEES:
            return produce(state, draft => {
                draft.calculatingFees = true;
            });
        case types.CALCULATE_FEES_SUCCESS:
            return produce(state, draft => {
                draft.calculatingFees = false;
                draft.feeCalculation = payload;
            });
        case types.CALCULATE_FEES_FAIL:
            return produce(state, draft => {
                draft.calculatingFees = false;
                draft.feeCalculation = undefined;
            });
        case campaignTypes.SET_SUBMISSION_MODAL_STATE:
            return produce(state, draft => {
                const { open, saleObject, currencyInfo } = payload || {};
                if (open) {
                    if (saleObject) draft.saleObject = saleObject;
                    if (currencyInfo) draft.currencyInfo = currencyInfo;
                } else {
                    draft.saleObject = undefined;
                    draft.currencyInfo = undefined;
                }
            });
        default:
            return state;
    }
};

export { reducer };
